module.exports = __webpack_public_path__ + "static/media/caigouhetong.d1ee2bb7.png";